
<div class="login">
  <section class="banner" />

  <section>
    <a href="https://www.cardladder.com">
      <full-logo pro />
    </a>

    <div class="form-container">
      <h1 class="secondary-font">
        Login
      </h1>

      <form @submit.prevent="login">
        <auth-form v-model="form" />

        <btn
          type="submit"
          block
          :loading="submitting"
          loading-text="Logging in"
        >
          Submit
        </btn>
      </form>

      <line-separator>OR</line-separator>

      <social-auth type="login" @complete="complete" />

      <div class="links">
        <a class="link" @click="$router.push({ path: '/forgot-password', query: $route.query })">Forgot your password?</a>
        <span>|</span>
        <a class="link" @click="$router.push({ path: '/signup', query: $route.query })">Create an account</a>
      </div>
    </div>
  </section>
</div>
